import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "../App";

/**
 * useGuidance — Hook to fetch contextual guidance for the current page.
 * Returns { guidance, loading } where guidance has:
 *   breadcrumb, next_steps, info_hint, support_options, quick_stats
 */
const useGuidance = () => {
  const location = useLocation();
  const [guidance, setGuidance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const page = location.pathname;
    fetch(`${API}/guidance/context?page=${encodeURIComponent(page)}`, { credentials: "include" })
      .then(res => res.ok ? res.json() : null)
      .then(data => setGuidance(data))
      .catch(() => setGuidance(null))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  return { guidance, loading };
};

export default useGuidance;
